import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaczkaPaletaType, ScreenType } from '../../enums/enums';
import { DeliveryOptionsPageComponent } from '../delivery-options-page/delivery-options-page.component';
import { MainOptionButtonComponent } from '../../common/main-option-buttom/main-option-button.component';
import { ParcelFormComponent } from './parcel-form/parcel-form.component';
import { PalettFormComponent } from './palett-form/palett-form.component';
import { PageHeaderComponent } from '../../common/page-header/page-header.component';
import { MainOptionButtonsWrapperComponent } from '../../common/main-option-buttons-wrapper/main-option-buttons-wrapper.component';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-create-shipment-page',
  standalone: true,
  imports: [
    CommonModule,
    DeliveryOptionsPageComponent,
    MainOptionButtonComponent,
    ParcelFormComponent,
    PalettFormComponent,
    PageHeaderComponent,
    MainOptionButtonsWrapperComponent,
  ],
  templateUrl: './create-shipment-page.component.html',
  styleUrl: './create-shipment-page.component.scss',
})
export class CreateShipmentPageComponent {
  ScreenType = ScreenType;

  PaczkaPaletaType = PaczkaPaletaType;
  paczkaPaletaType = PaczkaPaletaType.NADAJ_PACZKE;

  constructor(protected storeService: StoreService) {}
}
